module.exports = __webpack_public_path__ + "static/img/constractor_logo3.da1869c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/constractor_logo3.png
// module id = nhoy
// module chunks = 160